import { useEffect, useRef } from 'react';

// Browsers can emit both visibilitychange and focus for the same tab return.
// Refresh once after that pair, and never poll while the operator is away.
const useRefreshOnReturn = (refresh, delay = 250) => {
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;

  useEffect(() => {
    let away = document.hidden;
    let timeout;

    const markAway = () => {
      away = true;
      clearTimeout(timeout);
    };

    const refreshWhenVisible = () => {
      if (document.hidden || !away) return;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (document.hidden || !away) return;
        away = false;
        refreshRef.current();
      }, delay);
    };

    const onVisibilityChange = () => {
      if (document.hidden) markAway();
      else refreshWhenVisible();
    };

    window.addEventListener('blur', markAway);
    window.addEventListener('focus', refreshWhenVisible);
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('blur', markAway);
      window.removeEventListener('focus', refreshWhenVisible);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [delay]);
};

export default useRefreshOnReturn;
